import { Component, Input } from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { getYearlyCostsLabel } from '@innogy/become-a-customer/shared';

import { CommodityOfferContent } from '../../../commodity-offers.model';
import { CommodityOfferPriceBreakdownRowComponent } from '../commodity-price-breakdown-row/commodity-price-breakdown-row.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'wl-commodity-price-breakdown',
  templateUrl: './commodity-price-breakdown.component.html',
  styleUrls: [
    './commodity-price-breakdown.component.ed.scss',
    './commodity-price-breakdown.component.essent.scss',
  ],
  standalone: true,
  imports: [CommodityOfferPriceBreakdownRowComponent, CommonModule],
})
export class CommodityOfferPriceBreakdownComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offer?: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() content?: CommodityOfferContent;

  yearlyCostsLabel(offer: Offer) {
    return getYearlyCostsLabel(
      this.content?.yearlyCostsTotalDynamicWithIncentiveLabel ?? '',
      this.content?.yearlyCostsTotalDynamicWithoutIncentiveLabel ?? '',
      this.content?.yearlyCostsTotalWithIncentiveLabel ?? '',
      this.content?.yearlyCostsTotalWithoutIncentiveLabel ?? '',
      this.content?.yearlyCostsTotalMultiYearWithIncentiveLabel ?? '',
      this.content?.yearlyCostsTotalMultiYearWithoutIncentiveLabel ?? '',
      offer
    );
  }

  montlyCostsLabel(offer: Offer) {
    return offer.isDynamicProduct
      ? this.content?.monthlyCostsDynamicLabel
      : this.content?.monthlyCostsLabel;
  }

  budgetbillAmountLabel(offer: Offer) {
    return offer.isDynamicProduct
      ? this.content?.budgetbillAmountDynamicLabel
      : this.content?.budgetbillAmountLabel;
  }
}
